import React from 'react';
import * as S from './style';
import { SpaceDiv, Btn, BtnContainer } from 'components';
import FormItem, { Props as FormItemProps } from 'components/molecules/FormItem';
import FormProfile, { Props as FormProfileProps } from 'components/molecules/FormProfile';
import BtnNext, { Props as BtnNextProps } from 'components/molecules/BtnNext';
import FormInput, { Props as FormInputProps } from 'components/molecules/FormInput';
import { LABEL_BIRTHDAY, BUTTON_CANCEL } from 'commons/ZimssaString';

interface Props {
    title: string;
    profileImage: FormProfileProps;
    name: FormInputProps;
    phone: FormInputProps;
    birthDay: FormItemProps;
    btnNext: BtnNextProps;
    onClickCancel: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

function UserRegister({ title, ...props }: Props): React.ReactElement {
    return (
        <S.ContentsContainer>
            <S.ContentsWrapper>
                <S.TitleWrapper>
                    <S.TitleLabel contents={title} />
                </S.TitleWrapper>
                <S.ItemContainer>
                    <FormProfile {...props.profileImage} />
                    <FormInput {...props.name} />
                    <FormInput inputType={'NUMBER'} {...props.phone} />
                    <FormItem label={LABEL_BIRTHDAY} itemType={'ROW'} {...props.birthDay} />
                </S.ItemContainer>
            </S.ContentsWrapper>
            <SpaceDiv height={36} />
            <BtnContainer>
                <Btn backGroundColor={'gray_opacity_50'} boarderColor={'gray_opacity_200'} color={'gray_opacity_800'} fontStyle={'body1_bold'} height={64} onClick={props.onClickCancel}>
                    {BUTTON_CANCEL}
                </Btn>
                <BtnNext {...props.btnNext} />
            </BtnContainer>
        </S.ContentsContainer>
    );
}

export default UserRegister;
